import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from 'react';
export function useHeader(_ref) {
  var openUserInfo = _ref.openUserInfo,
      setOpenUserInfo = _ref.setOpenUserInfo;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isUserInfoOpen = _useState2[0],
      setIsUserInfoOpen = _useState2[1];

  return {
    isUserInfoOpen: openUserInfo !== null && openUserInfo !== void 0 ? openUserInfo : isUserInfoOpen,
    setIsUserInfoOpen: setOpenUserInfo !== null && setOpenUserInfo !== void 0 ? setOpenUserInfo : setIsUserInfoOpen
  };
}